// src/components/CommitInfo/index.tsx

import CommitInfo from './CommitInfo';

export * from './CommitInfo';
export default CommitInfo;